import React, { useEffect, useState } from 'react';
import background from '../assets/img/CGV_AEIM.png';
import { Document, Page, View, Text, Image, PDFViewer, StyleSheet } from '@react-pdf/renderer';
import logo from '../assets/img/logo_parc.png';
import axios from 'axios';
import { useLocation } from 'react-router-dom';

const Br = () => "\n";

const styles = StyleSheet.create({
  ligneArticle: {
    top: 350,
    flexDirection: 'row',
    marginTop: 2,
    marginLeft: 60,
    marginRight: 60,
    fontSize: 9,
    fontFamily: "Arial",
    color: "#73636d",
    alignItems: 'center',
  },
  colNum: { width: '7%' },
  colDesignation: { width: '40%'},
  colQte: { width: '13%', textAlign: 'right'},
  colPU: { width: '20%', textAlign: 'right' },
  colTotal: { width: '20%', textAlign: 'right' },
  
  container: {
    display: "flex",
    position: "absolute",
    width: "100%",
  },
  pageBackgroundContainer: {
    position: "relative",
    padding: "30",
    paddingBottom: "100",
    width: "100%",
    alignItems : "center",

  },
  imageBackground: {
    height: "100%",
    width: "100%",
  },
  imageLogo: {
    marginLeft: 190,
    marginTop: 0,
    height: "90%",
    width: "35%",
  },
  title: {
    fontWeight: "bold",
    marginLeft: 180,
    marginTop: 5,
    fontSize: 15,
    fontFamily: "Arial",
    color: "#73636d",
    textDecoration: "underline",
  },
  client: {
    marginLeft: 60,
    marginTop: 260,
    fontSize: 10,
    fontFamily: "Arial",
    color: "#73636d",
  },
  adresse_livraison: {
    marginLeft: 60,
    marginTop: 275,
    fontSize: 10,
    fontFamily: "Arial",
    color: "#73636d",
  },
  date_livraison: {
    marginLeft: 60,
    marginTop: 290,
    fontSize: 10,
    fontFamily: "Arial",
    color: "#73636d",
  },
  designation_titre: {
    marginLeft: 60,
    marginTop: 330,
    fontSize: 10,
    fontFamily: "Arial",
    color: "#73636d",
  },
  quantite_titre: {
    marginLeft: 325,
    marginTop: 330,
    fontSize: 10,
    fontFamily: "Arial",
    color: "#73636d",
  },
  prix_unitaire_ht_titre: {
    marginLeft: 400,
    marginTop: 330,
    fontSize: 10,
    fontFamily: "Arial",
    color: "#73636d",
  },
  total_ht_titre: {
    marginLeft: 500,
    marginTop: 330,
    fontSize: 9,
    fontFamily: "Arial",
    color: "#73636d",
  },
  total_ht_bot: {
    marginLeft: 330,
    marginTop: 620,
    fontSize: 9,
    fontFamily: "Arial",
    color: "#73636d",
  },
  prix_total_ht_bot: {
    textAlign :"right",
    marginRight: 60,
    marginTop: 620,
    fontSize: 9,
    fontFamily: "Arial",
    color: "#73636d",
  },
  livraison: {
    marginLeft: 330,
    marginTop: 640,
    fontSize: 9,
    fontFamily: "Arial",
    color: "#73636d",
  },
  livraison_corps: {
    textAlign :"right",
    marginRight: 60,
    marginTop: 640,
    fontSize: 9,
    fontFamily: "Arial",
    color: "#73636d",
  },
  remise: {
    marginLeft: 330,
    marginTop: 650,
    fontSize: 9,
    fontFamily: "Arial",
    color: "#73636d",
  },
  remise_corps: {
    textAlign :"right",
    marginRight: 60,
    marginTop: 650,
    fontSize: 9,
    fontFamily: "Arial",
    color: "#73636d",
  },
  tva1: {
    marginLeft: 330,
    marginTop: 665,
    fontSize: 9,
    fontFamily: "Arial",
    color: "#73636d",
  },
  tva_corps1: {
    textAlign :"right",
    marginRight: 60,
    marginTop: 665,
    fontSize: 9,
    fontFamily: "Arial",
    color: "#73636d",
  },
  tva2: {
    marginLeft: 330,
    marginTop: 677,
    fontSize: 9,
    fontFamily: "Arial",
    color: "#73636d",
  },
  tva_corps2: {
    textAlign :"right",
    marginRight: 60,
    marginTop: 677,
    fontSize: 9,
    fontFamily: "Arial",
    color: "#73636d",
  },
  total_prestation_ttc: {
    marginLeft: 330,
    marginTop: 689,
    fontSize: 9,
    fontFamily: "Arial",
    color: "#73636d",
  },
  total_prestation_ttc_corps: {
    textAlign :"right",
    marginRight: 60,
    marginTop: 689,
    fontSize: 9,
    fontFamily: "Arial",
    color: "#73636d",
  },
  text: {
    marginLeft: 60,
    marginTop: 730,
    fontSize: 8,
    fontFamily: "Arial",
    color: "#73636d",
  },
  text2: {
    marginLeft: 60,
    marginTop: 740,
    fontSize: 8,
    fontFamily: "Arial",
    color: "#73636d",
  },
  info: {
    marginLeft: 190,
    marginTop: 800,
    fontSize: 6,
    fontFamily: "Arial",
    color: "#73636d",
  },
  info2: {
    marginLeft: 240,
    marginTop: 808,
    fontSize: 6,
    fontFamily: "Arial",
    color: "#73636d",
  },
  info3: {
    marginLeft: 205,
    marginTop: 816,
    fontSize: 6,
    fontFamily: "Arial",
    color: "#73636d",
  },
});

function App() {
  const location = useLocation();
  const soc = location.state?.soc || "";
  const numero = location.state?.numero || "";
  return (
    <div className="App">
      <PDFViewer height="750" width="100%">
        <MyPDF 
        societe={soc}
        numerodocument={numero}/>
      </PDFViewer>
    </div>
  );
}

const LIGNES_PAR_PAGE = 22;

function paginateLignesAvecSousLignes(lignes) {
  const pages = [];
  let currentPage = [];
  let currentLineCount = 0;

  for (let i = 0; i < lignes.length; i++) {
    const article = lignes[i];

    // Récupère les spécificités et compte le nombre de lignes nécessaires
    let specifs = article.lib02 || article.LOTELIB02;
    if (typeof specifs === 'string') {
      specifs = specifs.split(/\n|,/).map(s => s.trim()).filter(Boolean);
    }
    let nbSpecifs = Array.isArray(specifs) ? specifs.length : (specifs ? 1 : 0);
    let linesNeeded = 1 + nbSpecifs;

    // Si pas assez de place sur la page, on passe à la suivante
    if (currentLineCount + linesNeeded > LIGNES_PAR_PAGE) {
      if (currentPage.length > 0) pages.push(currentPage);
      currentPage = [];
      currentLineCount = 0;
    }

    // Ajoute la ligne article principale
    currentPage.push({ ...article, isSpecif: false });
    currentLineCount++;

    // Ajoute les sous-lignes en associant par index
    if (Array.isArray(specifs)) {
      for (let j = 0; j < specifs.length; j++) {
        let prix_unitaire = '';
        if (Array.isArray(article.sous_lignes) && article.sous_lignes[j]) {
          prix_unitaire = article.sous_lignes[j].prix_unitaire;
        }
        currentPage.push({ ...article, isSpecif: true, specif: specifs[j], prix_unitaire });
        currentLineCount++;
      }
    } else if (specifs) {
      let prix_unitaire = '';
      if (Array.isArray(article.sous_lignes) && article.sous_lignes[0]) {
        prix_unitaire = article.sous_lignes[0].prix_unitaire;
      }
      currentPage.push({ ...article, isSpecif: true, specif: specifs, prix_unitaire });
      currentLineCount++;
    }
  }
  if (currentPage.length > 0) {
    pages.push(currentPage);
  }
  return pages;
}

const MyPDF = ({ societe, numerodocument }) => {
  const [enteteDocument, setEnteteDocument] = useState({});
  const [lignesDocument, setLignesDocument] = useState([]);
  const [detailsClient, setDetailsClient] = useState({});
  const paginatedLignes = paginateLignesAvecSousLignes(lignesDocument);

  const [montantTTC, setMontantTTC] = useState(0);
  const [montantHT, setMontantHT] = useState(0);
  const [baseTVA, setBaseTVA] = useState({});
  const [montantTVA, setMontantTVA] = useState({});
  const [detailsTVA, setDetailsTVA] = useState({});

  const [montantTransport, setMontantTransport] = useState(0);

  let articleNumber = 1;

  console.log(paginatedLignes);


  useEffect(() => {
    if (societe && numerodocument) {
      axios.get(`/devis/${societe}/${numerodocument}`)
        .then((response) => {
          setEnteteDocument(response.data.entete || {});
          setLignesDocument(Array.isArray(response.data.lignes) ? response.data.lignes : []);
        })
        .catch((error) => {
          console.error("Erreur lors de la récupération du devis :", error);
        });
    }
  }, [societe, numerodocument]);

  useEffect(() => {
    if (enteteDocument && enteteDocument.compte) {
      axios.get(`/client_by_number?soc=${societe}&numero=${enteteDocument.compte}`)
        .then((response) => {
          setDetailsClient(response.data[0]);
        })
        .catch((error) => {
          console.error("Erreur lors de la récupération des infos client :", error);
        });
    }
  }, [enteteDocument, societe]);

  const adresse_client = (data) => {
    if (!data) return '';
    const rue1 = data.rue1 || '';
    const rue2 = data.rue2 || '';
    const cpVille = [data.cp, data.ville].filter(Boolean).join(' ');
    const pays = data.pays || '';
    const adresseComplete = [rue1, rue2, cpVille, pays].filter(Boolean).join(', ');
    // Si l'adresse est longue (>65) ET qu'il y a une rue2, saut de ligne après rue2
    if (adresseComplete.length > 70 && rue2) {
      return (
        <>
          {[rue1, rue2].filter(Boolean).join(', ')}
          {'\n'}
          {[cpVille, pays].filter(Boolean).join(', ')}
        </>
      );
    }
    // Sinon, une seule ligne normale
    return adresseComplete;
  };

// Pour le marginTop, on veut la longueur de l'adresse en string
  const adresseClientString = (() => {
    if (!detailsClient) return '';
    const rue1 = detailsClient.rue1 || '';
    const rue2 = detailsClient.rue2 || '';
    const cpVille = [detailsClient.cp, detailsClient.ville].filter(Boolean).join(' ');
    const pays = detailsClient.pays || '';
    return [rue1, rue2, cpVille, pays].filter(Boolean).join(', ');
  })();

  const remplace_point = (s) => {
    if (s) {
      var t = s.toString();
      return t.replace('.',',');
    }
  }

    useEffect(() => {
  
      if (lignesDocument.length != 0) {
        
        const data = {};
  
        lignesDocument.forEach(ligne => {
              data[ligne.ligne] = {
                taux: ligne.tva,
                base: ligne.valeur,
                montant_ttc: parseFloat(parseFloat(ligne.valeur)*(1+(parseFloat(ligne.tva)/100))).toFixed(2),
              };
            });
  
        var transport = parseFloat(enteteDocument.distance).toFixed(2);
  
        data[lignesDocument.length] = {
                taux: "20.00",
                base: transport,
                montant_ttc: parseFloat(transport*(1+(parseFloat(20)/100))).toFixed(2)
        }
          
        setDetailsTVA(data);
  
        let montant_total = 0;
        let montant_ht = 0
  
        let splitBaseTVA = {};
        let splitMontantTVA = {};
  
        for(let i=0;i<Object.keys(data).length;i++) {
  
          if (!splitBaseTVA[data[i].taux] && !splitMontantTVA[data[i].taux]) {
            splitBaseTVA[data[i].taux] = parseFloat(data[i].base);
            splitMontantTVA[data[i].taux] = parseFloat(data[i].base)*(parseFloat(data[i].taux)/100);
  
          }
          else {
            splitBaseTVA[data[i].taux] += parseFloat(data[i].base);
            splitMontantTVA[data[i].taux] += parseFloat(data[i].base)*(parseFloat(data[i].taux)/100);
          } 
  
          montant_total += parseFloat(data[i].montant_ttc);
          montant_ht += parseFloat(data[i].base);
        }

        console.log(data);
  
        setMontantTransport(transport);
        setMontantTTC(montant_total.toFixed(2));
        setMontantHT(montant_ht.toFixed(2));
        setBaseTVA(splitBaseTVA);
        setMontantTVA(splitMontantTVA);
      }
    }, [lignesDocument, societe]);

  return (
    <Document>
      {paginatedLignes.map((lignesPage, pageIndex) => (
        <Page size="A4" key={pageIndex}>
          <View style={styles.container}>
            <Image src={logo} style={styles.imageLogo} />
            <Text style={styles.title}>Bon de commande Plateaux Repas</Text>
          </View>
          <View style={styles.container}>
            <Text style={styles.client}>Client : {detailsClient.nom || ''}</Text>
          </View>
          <View style={styles.container}>
            <Text style={styles.adresse_livraison}>
              Adresse de Livraison : {adresse_client(detailsClient)}
            </Text>
          </View>
          <View style={styles.container}>
            <Text
              style={{
                ...styles.date_livraison,
                marginTop:
                  adresseClientString.length > 70 && detailsClient?.rue2
                    ? styles.date_livraison.marginTop + 13
                    : styles.date_livraison.marginTop,
              }}
            >
              Date de livraison :{' '}
              {lignesDocument.length > 0 && lignesDocument[0].delai
                ? new Date(lignesDocument[0].delai).toLocaleDateString('fr-FR')
                : ''}
            </Text>
          </View>
          <View style={styles.container}>
            <Text style={styles.designation_titre}>#              Désignation</Text>
          </View>
          <View style={styles.container}>
            <Text style={styles.quantite_titre}>Quantité</Text>
          </View>
          <View style={styles.container}>
            <Text style={styles.prix_unitaire_ht_titre}>Prix Unitaire HT</Text>
          </View>
          <View style={styles.container}>
            <Text style={styles.total_ht_titre}>Total HT</Text>
          </View>
          {lignesPage.map((ligne, idx) =>
            !ligne.isSpecif ? (
              <View key={idx}>
                <View style={styles.ligneArticle}>
                  <Text style={styles.colNum}>
                    {articleNumber++}.
                  </Text>
                  <Text style={styles.colDesignation}>
                    {ligne.lib01 || ligne.LOVALIB01 || ''}
                  </Text>
                  <Text style={styles.colQte}>
                    {ligne.qte_exp || ligne.LOINQTEEXP || ''}
                  </Text>
                  <Text style={styles.colPU}>
                  </Text>
                  <Text style={styles.colTotal}>
                    {ligne.valeur || ligne.LONUVAL || ''}
                  </Text>
                </View>
              </View>
            ) : (
              <View key={idx}>
                <View style={styles.ligneArticle}>
                  <Text style={styles.colNum}>{/* vide pour alignement */}</Text>
                  <Text style={{ ...styles.colDesignation, fontSize: 7, color: '#888888' }}>
                    {
                      (() => {
                        const match = (ligne.specif || '').match(/^([^(]*)/);
                        return match ? match[1].trim() : ligne.specif;
                      })()
                    }
                  </Text>
                  <Text style={{ ...styles.colQte, fontSize: 7, color: '#888888' }}>
                    {
                      (() => {
                        const matches = [...(ligne.specif.matchAll(/\(([^()]*)\)/g) || [])];
                        return matches.length > 0 ? matches[matches.length - 1][1] : '';
                      })()
                    }
                  </Text>
                  <Text style={{ ...styles.colPU, fontSize: 7, color: '#888888' }}>
                    {ligne.prix_unitaire !== undefined && ligne.prix_unitaire !== null && ligne.prix_unitaire !== ''
                      ? Number(ligne.prix_unitaire).toFixed(2)
                      : ''}
                  </Text>
                  <Text style={{ ...styles.colTotal, fontSize: 7, color: '#888888' }}>
                    {
                      (() => {
                        const matches = [...(ligne.specif.matchAll(/\(([^()]*)\)/g) || [])];
                        const qte = matches.length > 0 ? parseFloat(matches[matches.length - 1][1]) : 0;
                        const pu = parseFloat(ligne.prix_unitaire || 0);
                        return qte && pu ? (qte * pu).toFixed(2) : '';
                      })()
                    }
                  </Text>
                </View>
              </View>
            )
          )}
          <View style={styles.container}>
            <Text style={styles.total_ht_bot}>Total HT</Text>
          </View>
          <View style={styles.container}>
            <Text style={styles.prix_total_ht_bot}>
              {montantHT ? `${remplace_point(montantHT)} €` : ''}
            </Text>
          </View>
          <View style={styles.container}>
            <Text style={styles.livraison}>Livraison</Text>
          </View>
          <View style={styles.container}>
            <Text style={styles.livraison_corps}>
              {typeof enteteDocument.distance !== 'undefined' ? `${remplace_point(enteteDocument.distance.toFixed(2))} €` : ''}
            </Text>
          </View>
          <View style={styles.container}>
            <Text style={styles.remise}>Remise </Text>
          </View>
          <View style={styles.container}>
            <Text style={styles.remise_corps}></Text>
          </View>
          <View style={styles.container}>
            <Text style={styles.tva1}>TVA 20%</Text>
          </View>
          <View style={styles.container}>
            <Text style={styles.tva2}>TVA 10%</Text>
          </View>
          <View style={styles.container}>
            <Text style={styles.tva_corps1}>
              {typeof montantTVA["20.00"] !== 'undefined'
                ? `${remplace_point(montantTVA["20.00"].toFixed(2))} €`
                : '0,00 €'}
            </Text>
          </View>
          <View style={styles.container}>
            <Text style={styles.tva_corps2}>
              {typeof montantTVA["10.00"] !== 'undefined'
                ? `${remplace_point(montantTVA["10.00"].toFixed(2))} €`
                : '0,00 €'}
            </Text>
          </View>
          <View style={styles.container}>
            <Text style={styles.total_prestation_ttc}>Total TTC </Text>
          </View>
          <View style={styles.container}>
            <Text style={styles.total_prestation_ttc_corps}>
              {montantTTC ? `${remplace_point(montantTTC)} €` : '0'}
            </Text>
          </View>
          <View style={styles.container}>
            <Text style={styles.text}>Nous retourner le bon de commande signé avec mention "BON POUR ACCORD" et la date.</Text>
          </View>
          <View style={styles.container}>
            <Text style={styles.text2}>La signature du bon de commande vaut acceptation des conditions générales de ventes ci-dessous.</Text>
          </View>
          <View style={styles.container}>
            <Text style={styles.info}>BRASSERIE DU PARC STE MARIE | RUE DURIVAL | 54000 NANCY | FRANCE</Text>
          </View>
          <View style={styles.container}>
            <Text style={styles.info2}>06 19 50 17 62 | didier.valentin@aeim54.fr</Text>
          </View>
          <View style={styles.container}>
            <Text style={styles.info3}>TVA non applicable, art. 293 B d | AEIM | SIRET 77561559400717</Text>
          </View>
          <Text
            style={{
              position: 'absolute',
              bottom: 20,
              right: 60,
              fontSize: 9,
              fontFamily: 'Arial',
              color: '#73636d',
              textAlign: 'right'
            }}
          >
            Page {pageIndex + 1} / {paginatedLignes.length}
          </Text>
        </Page>
      ))}
      <Page size="A4">
        <View>
          <Image src={background} style={styles.imageBackground} />
        </View>

      </Page>
      
    </Document>
  );
}

export default App;
